import styled from 'styled-components';

import { LinkButton } from 'brand-guidelines/Buttons-styled-components';
import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { BaseBodyText } from 'pages/checkout-v3/components/common/typographic-styled-components';

export const Wrapper = styled.div`
  display: grid;
  grid-template-areas:
    'photo text'
    'photo logout';
  grid-auto-columns: minmax(0, max-content);

  padding: 12px 16px;
  column-gap: 16px;

  align-items: center;

  border-radius: 8px;
  border: 1px solid ${BRAND_COLORS.stroke};
`;

export const PhotoWrapper = styled.div`
  grid-area: photo;
  width: 28px;
  height: 28px;

  border-radius: 50%;
  overflow: clip;

  object-fit: cover;
  object-position: center;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Text = styled(BaseBodyText)`
  grid-area: text;
`;

export const UserName = styled.span`
  ${TYPOGRAPHY.OPEN_SANS.semiBold}
  color: ${BRAND_COLORS.black};
`;

export const Logout = styled(LinkButton)`
  grid-area: logout;
  ${TYPOGRAPHY.OPEN_SANS.semiBold}
  color: ${BRAND_COLORS.darkGray};
  font-size: 14px;
  line-height: 22px;

  text-align: left;
  text-decoration: underline;
`;
